
/* eslint-disable no-restricted-syntax */
import { Component } from 'vue-property-decorator';
import TowersTemplate from '@/components/towers/TowersTemplate.vue';

@Component({
  components: {
    TowersTemplate,
  },
})

// TowersTemplate contains all important functions for the Tower game
export default class Map22 extends TowersTemplate {
  availableTowers = 4;

  optimalNrOfTowers = 3;

  nrOfFields = 6;

  fields = [false, false, false, false, false, false];

  initGraph():void {
    for (let i = 0; i < this.nrOfFields; i += 1) {
      this.map.addVertex(i);
    }

    // Skizze 3: 6 Knoten, Start oben links nach unten rechts
    this.map.addEdge(0, 1);
    this.map.addEdge(1, 2);
    this.map.addEdge(0, 3);
    this.map.addEdge(0, 4);
    this.map.addEdge(1, 4);
    this.map.addEdge(2, 4);
    this.map.addEdge(2, 5);
  }
}
